import React, { ReactNode } from 'react';
import * as S from './styles';

interface BankInfoProps {
  data: {
    label?: string;
    value: ReactNode;
    boldLabel?: boolean;
  }[];
}

const BankInfo: React.FC<BankInfoProps> = ({ data }) => (
  <>
    {data.map((entry) => (
      <S.BankDetailItem component="section" key={entry?.label}>
        {entry?.label && (
          <S.BankInfoLabel
            isBold={entry.boldLabel}
            component="span"
          >{`${entry?.label}: `}</S.BankInfoLabel>
        )}
        {entry.value}
      </S.BankDetailItem>
    ))}
  </>
);
export default BankInfo;
